import { createReducer } from 'redux-starter-kit';
import { fetchInspection, sendInspectionReport } from './inspectionUiActions';
import { selectRequest } from '../../domain/requests/RequestReducer';
import { selectInspection } from '../../domain/inspection/inspectionReducer';


/**
 * A selector for the current inspection request state
 * @param {object} state The redux state of the application.
 */
export const selectInspectionRequest = (state) => {
  const requestId = state.via.ui.inspection.requestInspectionId;
  if (!requestId) return null;

  return selectRequest(state, requestId);
};

/**
 * A selector for the current loaded inspection.
 * @param {object} state The redux state of the application.
 */
export const selectCurrentInspection = (state) => {
  const request = selectInspectionRequest(state);
  if (!request || !request.payload) return null;

  return selectInspection(state, request.payload);
};

/**
 * A selector for the current loaded inspection.
 * @param {object} state The redux state of the application.
 */
export const selectSendReportRequest = (state) => {
  const requestId = state.via.ui.inspection.requestSendReportId;
  if (!requestId) return null;

  return selectRequest(state, requestId);
};


const inspectionInitialState = {
  requestInspectionId: null,
  requestSendReportId: null,
};

const inspectionUiReducer = createReducer(inspectionInitialState, {
  [fetchInspection]: (state, action) => ({
    ...inspectionInitialState,
    requestInspectionId: action.payload,
  }),

  [sendInspectionReport]: (state, action) => ({
    ...state,
    requestSendReportId: action.payload,
  }),
});

export default inspectionUiReducer;
